/**
 * FAQ section
 * ---------------------------------------------------------------------------
 * Extracted from sections/faq.liquid, where it was inline <script>.
 * Inline scripts are parser-blocking, uncacheable, and re-sent on every page
 * view. This asset is deferred and cached, and initialises every instance on
 * the page instead of binding to a single section id.
 *
 * Initialisation is idempotent: an already-wired element is skipped.
 */
(function () {
  'use strict';

  var SELECTOR = '[data-section-type="faq"]';

  function initSection(sectionEl) {
    if (!sectionEl || sectionEl.dataset.faqInit === 'true') return;
    sectionEl.dataset.faqInit = 'true';

    var sectionId = sectionEl.dataset.sectionId;
    const triggers = sectionEl.querySelectorAll('.custom-faq__trigger');

    triggers.forEach((btn) => {
      btn.addEventListener('click', function () {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        const targetId = this.getAttribute('aria-controls');
        const answerEl = sectionEl.querySelector('#' + targetId);

        if (!answerEl) return;

        if (isExpanded) {
          this.setAttribute('aria-expanded', 'false');
          answerEl.style.display = 'none';
        } else {
          this.setAttribute('aria-expanded', 'true');
          answerEl.style.display = 'block';
        }
      });
    });
  }

  function initAll(root) {
    var scope = root || document;
    // On shopify:section:load the event target IS the section element, and
    // querySelectorAll only looks at descendants - so test the root itself too.
    if (scope.matches && scope.matches(SELECTOR)) initSection(scope);
    Array.prototype.forEach.call(scope.querySelectorAll(SELECTOR), initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
